export const iconFontAwesomeArrowsRightFromBracket = (
	<i className="fa-solid fa-right-from-bracket"></i>
);
